import script from "./GameOverScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameOverScreen.vue?vue&type=script&setup=true&lang=ts"

import "./GameOverScreen.vue?vue&type=style&index=0&id=06188cc8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/The-Jojo-Tree/The-Jojo-Tree/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06188cc8"]])

export default __exports__